import app from '@breakmedia/prime-vue-client';
import { INFORMATION_STORAGE_ACCESS_ITEM, MEASUREMENT_ITEM } from '@breakmedia/prime-vue-privacy/src/constants';
import Vue from 'vue';
import './assets/custom.styl';
import './registerServiceWorker';
import complaints from './routes/complaints';
import checkout from './routes/checkout';
import VueLazyRenderer from 'vue-lazy-renderer';
import billingAddressModule from './components/checkout/AddressStep/store/billingAddress';
import registrationModule from './components/checkout/AddressStep/store/registration';

app.bootstrapComponents.vuetify.options = {
    iconfont: 'md',
    options: {
        customProperties: true,
    },
};

app.bootstrapComponents.vuetify.options.theme = {
    primary: '#FA5F0F', //Can be used with darken-1 & lighten-1
    secondary: '#343434', //Can be used with lighten-2
    accent: '#FA5F0F', //Info, warning color
    info: {
        base: '#9b9b9b',
        lighten4: '#e6e6e6',
    },
    font: '#404040',
    light: {
        base: '#ffffff',
        darken1: '#bababa',
    },
    lightorange: '#f4ab76',
    //Neon theme
    neongreen: '#b4ff3b',
    neonmint: '#04ff80',
    neonturquoise: '#0afaf1',
    neonpurple: '#fd0abc',
    neonpink: '#fa0a70',
    //Dark theme
    darkblue: '#053076',
    darkgreen: '#93c63e',
    darkpetrol: '#0c8077',
    darkpurple: '#871a71',
    darkred: '#b52a50',
    //Pastel theme
    pastelrose: '#fba0b3',
    pastelpink: '#fe99dc',
    pastelblue: '#91e3f1',
    pastelmint: '#77fcc9',
    pastelgreen: '#b2fc98',
};
app.bootstrapComponents.vuetify.options.theme = {
    ...app.bootstrapComponents.vuetify.options.theme,
    'header-toolbar-top': '#fff',
    'header-toolbar-bottom': app.bootstrapComponents.vuetify.options.theme.secondary,
    'header-toolbar-top-text': app.bootstrapComponents.vuetify.options.theme.secondary,
    'header-toolbar-top-text-mobile': '#fff',
    'footer-toolbar-top': app.bootstrapComponents.vuetify.options.theme.info.lighten4,
    'footer-toolbar-bottom': app.bootstrapComponents.vuetify.options.theme.secondary,
    // 'footer-toolbar-top-text': app.bootstrapComponents.vuetify.options.theme.light,
};

app.metaInfo.title = 'GrillShop';

app.simpleComponents['privacy-consent-item'] = () =>
    import(
        // eslint-disable-next-line max-len
        /* webpackChunkName: "default" */ '@breakmedia/prime-vue-privacy/src/components/PrivacyConsent/PrivacyConsentItem'
    );
app.simpleComponents['product-thumbnail'] = () =>
    import(/* webpackChunkName: "product" */ './components/product/ProductThumbnail');
app.simpleComponents['product-price'] = () =>
    import(/* webpackChunkName: "product" */ './components/product/ProductPrice.vue');
app.simpleComponents['merchants-offers'] = () =>
    import(/* webpackChunkName: "product" */ './components/product/MerchantsOffers');
app.simpleComponents['images-and-videos'] = () =>
    import(/* webpackChunkName: "product" */ './components/product/ImagesAndVideos');
app.simpleComponents['product-sidebar'] = () =>
    import(/* webpackChunkName: "product" */ './components/product/ProductSidebar');
app.simpleComponents['info-bar'] = () =>
    import(/* webpackChunkName: "page" */ '@breakmedia/prime-vue-page/src/page-components/info/InfoBar');
app.simpleComponents['expansion-panel'] = () =>
    import(/* webpackChunkName: "page" */ '@breakmedia/prime-vue-page/src/page-components/vuetify/ExpansionPanel');
app.simpleComponents['basket-item'] = () =>
    import(/* webpackChunkName: "basket" */ './components/basket/BasketItem.vue');
app.simpleComponents['basket-totals'] = () =>
    import(/* webpackChunkName: "basket" */ './components/basket/BasketTotals.vue');
app.simpleComponents['summary-step'] = () =>
    import(/* webpackChunkName: "checkout" */ './components/checkout/SummaryStep/SummaryStep');
app.simpleComponents['paid-coupon'] = () =>
    import(/* webpackChunkName: "checkout" */ '@breakmedia/prime-vue-coupon/src/PaidCoupon');
app.simpleComponents['product-short-description'] = () =>
    import(/* webpackChunkName: "product" */ './components/product/ProductShortDescription');

app.simpleComponents['checkout-billing-address-default'] = () =>
    import('./components/checkout/AddressStep/BillingAddress');

app.simpleComponents['checkout-registration-default'] = () =>
    import('./components/checkout/AddressStep/Registration/default/Registration');

app.simpleComponents['search-box'] = () => import(/* webpackChunkName: "search" */ './components/search/SearchBox');
app.simpleComponents['account-navigation'] = () =>
    import(/* webpackChunkName: "page" */ './components/customer/AccountNavigation.vue');
app.simpleComponents['video-player'] = () => import(/* webpackChunkName: "page" */ './components/page/VideoPlayer');
app.simpleComponents['product-customer-info'] = () =>
    import(/* webpackChunkName: "product" */ './components/product/ProductCustomerInfo');
app.metaInfo.titleTemplate = '%s';

app.data.mainNavDrawer = false;
app.data.showLanguageModal = false;
app.data.contactWidgetDrawer = null;
app.data.contactWidgetHeight = window.innerHeight - 84;
app.data.contactWidgetWidth = window.innerWidth;
app.data.sidebarNavMini = true;
app.data.showModalOne = false;
app.data.showModalTwo = false;
app.data.showShippingModal = false;

app.methods = {
    onResize() {
        (this.contactWidgetHeight = window.innerHeight - 84), (this.contactWidgetWidth = window.innerWidth);
    },
};
app.watch = {
    $route(to, from) {
        this.sidebarNavMini = true;
    },
};

app.plugins.search.options.searchResultGridClasses = 'xs6 sm6 md4';

app.plugins.gtm = {
    instance: () => import(/* webpackChunkName: "page" */ '@breakmedia/prime-vue-gtm'),
    options: {},
    priority: 100,
};

app.plugins.grillshop = {
    instance: () => import(/* webpackChunkName: "default" */ './plugin/grillshop'),
    options: {},
    priority: 1000,
};

app.plugins.customer = {
    instance: () => import(/* webpackChunkName: "default" */ './components/customer/plugin/customer'),
    options: {},
    priority: 100,
};

app.plugins.order = {
    instance: () => import(/* webpackChunkName: "order" */ './components/checkout/plugin/order'),
    options: {},
    priority: 100,
};

app.plugins.basket = {
    instance: () => import(/* webpackChunkName: "basket" */ '@breakmedia/prime-vue-basket/src/plugin/basket'),
        options: {},
    priority: 100,
    callback: () => {
        Vue.$basket.sync(false, true);
    }
},

app.bootstrapComponents.privacy = {
    instance: () => import(/* webpackChunkName: "default" */ '@breakmedia/prime-vue-privacy/src/plugin'),
    options: {
        component: () =>
                import(
                    /* webpackChunkName: "default" */ '@breakmedia/prime-vue-privacy/src/components/PrivacyConsent/PrivacyConsent'
                ),
        items: [INFORMATION_STORAGE_ACCESS_ITEM, MEASUREMENT_ITEM],
    },
    priority: 0,
};

app.payments.prepayment = {
    instance: () =>
        import(/* webpackChunkName: "checkout" */ '@breakmedia/grillshop-vue-payment-vorauskasse/src/Vorauskasse'),
    options: {},
};

app.payments.cashOnDelivery = {
    instance: () => import(/* webpackChunkName: "checkout" */ '@breakmedia/grillshop-vue-payment-cash/src/Cash'),
    options: {},
};

app.payments.amazonPaymentType = {
    instance: () =>
        import(/* webpackChunkName: "checkout" */ '@breakmedia/prime-vue-payment-amazon/src/AmazonPaymentType'),
    options: {},
};

app.payments.payver = {
    instance: () => import(/* webpackChunkName: "checkout" */ '@breakmedia/prime-vue-payment-payever/src/Payever'),
    options: {},
};


app.payments.klarnaPaymentType = {
    instance: () =>
        import(/* webpackChunkName: "checkout" */ '@breakmedia/prime-vue-payment-klarna/src/KlarnaPaymentType'),
    options: {},
};

app.payments.adyen = {
    instance: () => import(/* webpackChunkName: "checkout" */ '@breakmedia/prime-vue-payment-adyen/src/index'),
    options: {},
};

app.payments.coinbase = {
    instance: () => import(/* webpackChunkName: "checkout" */ '@breakmedia/prime-vue-payment-coinbase/src/CoinbasePaymentType'),
    options: {},
};

app.routerConfig.routes = Object.assign(app.routerConfig.routes, checkout);
app.routerConfig.routes = Object.assign(app.routerConfig.routes, complaints);

app.prepareInstance().then(() => {
    Vue.use(VueLazyRenderer, {throttledWait: 1000});
    new Vue(app);
    // Vue.config.performance = true;

    Vue.$router.afterEach(() => {
        app.data.mainNavDrawer = false;
    });
    Vue.$store.registerModule('BillingAddressForm', billingAddressModule);
    Vue.$store.registerModule('Registration', registrationModule);

});
